/**
 * Reglas de adjuntos del módulo Tareas. Deben coincidir con
 * `server/src/constants/taskUploads.js`, que es quien valida de verdad.
 */
import {
    IMAGE_UPLOAD_MAX_BYTES,
    FILE_UPLOAD_MAX_BYTES,
    COURSE_UPLOAD_ACCEPT,
    COURSE_UPLOAD_HINT,
    validateCourseFile,
} from './courseFiles';

export {
    formatFileSize,
    getAttachmentKind,
    isImageAttachment,
    ATTACHMENT_KIND_LABELS,
    getFileExtension,
    resolveMimeType,
    asAttachmentList,
    canPreviewInBrowser,
} from './courseFiles';

export const TASK_UPLOAD_MAX_BYTES = IMAGE_UPLOAD_MAX_BYTES;
export const TASK_FILE_UPLOAD_MAX_BYTES = FILE_UPLOAD_MAX_BYTES;
export const TASK_MAX_ATTACHMENTS = 10;
export const TASK_UPLOAD_ACCEPT = COURSE_UPLOAD_ACCEPT;
export const TASK_UPLOAD_HINT = `${COURSE_UPLOAD_HINT} · hasta 10 archivos`;

export const validateTaskFile = (file) => validateCourseFile(file);
